import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as Failed } from "../../assets/icons/cancel.svg";
import { ReactComponent as Success } from "../../assets/icons/checked.svg";

const ICON_SIZE = "20px";
const ICON_STYLE = { width: ICON_SIZE, height: ICON_SIZE, margin: "auto" };

const CheckResult = ({ isSuccess }) => {
  return isSuccess ? (
    <Success style={ICON_STYLE} />
  ) : (
    <Failed style={ICON_STYLE} />
  );
};

CheckResult.propTypes = {
  isSuccess: PropTypes.bool.isRequired
};

export default CheckResult;
